<template>
  <v-badge bordered color="accent" overlap :content="count" :value="count">
    <slot />
  </v-badge>
</template>

<script>
export default {
  data() {
    return {
      subs: [],
      count: 0,
    };
  },
  mounted() {
    const morale = this.$auth.hasRole(
      'PRIV_TRAITEMENT_DEMANDE_PERSONNE_MORALE',
    );
    const physique = this.$auth.hasRole(
      'PRIV_TRAITEMENT_DEMANDE_PERSONNE_PHYSIQUE',
    );
    const mobile = this.$auth.hasRole('PRIV_TRAITEMENT_DEMANDE_CONTACT');
    const instance = this.$auth.hasRole('PRIV_TRAITEMENT_DEMANDE_INSTANCE');
    const inscription = this.$auth.hasRole(
      'PRIV_TRAITEMENT_DEMANDE_INSCRIPTION',
    );

    if (morale || physique || mobile || instance || inscription) {
      ['/topic/demandes', '/app/demandes'].forEach(item => {
        this.subs.push(this.$stomp.subscribe(item, this.receive));
      });
    }
  },
  unmounted() {
    this.subs.forEach(s => s.unsubscribe());
  },
  methods: {
    receive(msg) {
      const morale = this.$auth.hasRole(
        'PRIV_TRAITEMENT_DEMANDE_PERSONNE_MORALE',
      );
      const physique = this.$auth.hasRole(
        'PRIV_TRAITEMENT_DEMANDE_PERSONNE_PHYSIQUE',
      );
      //const mobile = this.$auth.hasRole('PRIV_TRAITEMENT_DEMANDE_CONTACT');
      const instance = this.$auth.hasRole('PRIV_TRAITEMENT_DEMANDE_INSTANCE');
      const inscription = this.$auth.hasRole(
        'PRIV_TRAITEMENT_DEMANDE_INSCRIPTION',
      );

      this.count =
        (physique ? msg.contacts : 0) +
        (instance ? msg.instances : 0) +
        (morale ? msg.personnesMorales : 0) +
        (inscription ? msg.inscriptions : 0);
    },
  },
};
</script>
